import { useAssetAllocationPDF } from "../../Hooks/Features/InventoryDashboard/useAssetAllocationPDF"

const AssetAllocationPDF = ({ editData, assignValues, options }) => {

    const {dataContent} = useAssetAllocationPDF({editData, assignValues, options})

    return (
        <div className="py-5 px-5 border border-4 border-black h-100 text-black" style={{fontSize: "0.80rem", lineHeight: "1.1rem"}}>
            <div className="text-center">
                <img src="./assets/srkay-logo-light.png" height={50} alt="company-logo" />
            </div>
            <div className="text-uppercase mt-4 fw-bold text-center">Asset allocation form</div>
            <div className="my-2 border-bottom border-top border-2 border-black py-4 px-2">
                <div>
                    To, <br />
                    <span className="fw-bold">SRKay IT Team,</span> <br />
                    : <span> SRKay Consulting Group Pvt. Ltd.
                        {editData?.location_name?.toLowerCase()?.trim() === "surat" ?
                            " W-04A, Gems and Jewellery Park GHB, Ichhapore – Hazira, Surat – 394510 " :
                            editData?.location_name?.toLowerCase()?.trim() === "pune" ? " IndiQube Park Plaza, 4th Floor 465/C1, CTS - 1085, Ganeshkhind Road,next to Central Mall, Shivajinagar, Pune, Maharashtra - 411005" : ""
                        }
                    </span>
                </div>
                <div className="my-4">
                    I, <span className="text-decoration-underline fw-bold">&nbsp;&nbsp;&nbsp;&nbsp;{assignValues?.assign_to?.user_display_name?.split("[")?.[0] || " "}&nbsp;&nbsp;&nbsp;&nbsp;</span> Emp ID No: <span className="text-decoration-underline fw-bold">&nbsp;&nbsp;&nbsp;&nbsp;{assignValues?.assign_to?.employee_id}&nbsp;&nbsp;&nbsp;&nbsp;</span> have allocated the following items from SRKay Consulting Group Pvt. Ltd.
                </div>
                <table>
                    <thead>
                        <tr className="border border-black">
                            <th className="border-end border-black p-0 text-center">Sr.No</th>
                            <th className="border-end border-black p-0 text-center">Nomenclature</th>
                            <th className="border-end border-black p-0 text-center">Qty</th>
                            <th className="border-end border-black p-0 text-center">Remarks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataContent?.table?.map((item, idx) => (
                            <tr key={idx} className="border border-black">
                                <td className="border-end border-black p-0 text-center">{idx + 1}</td>
                                <td className="border-end border-black p-0 ps-2">{item?.nomenclature}</td>
                                <td className="border-end border-black p-0 text-center">{item?.count || ""}</td>
                                <td className="border-end border-black p-0 ps-2"></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="mt-4">
                    {dataContent?.attributes?.map((item, idx) => (
                        <div className="d-flex gap-3">
                            <div className="w45 d-flex justify-content-between"><span>{item?.label}</span> - </div>
                            <div className="fw-semibold">{item?.value || ""}</div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="py-2 px-1">
                <div className="text-center fw-bold text-decoration-underline my-2">Undertaking</div>
                <p>The above items are the property of SRKay Consulting Group PVT. LTD and are issued to me, exclusively for my professional/official use. I undertake not to misuse the items. In cases of theft or loss of devices, the recovery process in the ‘Company Asset Policy’ would be followed.</p>
            </div>
            <div className="d-flex justify-content-between p-4 w95">
                <div className="w45">Date: </div>
                <div className="w55 d-flex flex-column gap-2">
                    <div>Employee Signature: </div>
                    <div>Employee Name: </div>
                    <div>Employee Contact No.: </div>
                </div>
            </div>
        </div>
    )
}

export default AssetAllocationPDF